var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.54,
    height: 15.738,
    viewBox: "0 0 22.54 15.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.14 7.734a2.831 2.831 0 0 0-2.4-2.267c-2.8-.267-5.6-.267-8.4-.267s-5.6 0-8.4.267A2.84 2.84 0 0 0 .4 7.734a23.985 23.985 0 0 0-.4 5.335A23.985 23.985 0 0 0 .4 18.4a2.831 2.831 0 0 0 2.4 2.267c2.8.267 5.6.267 8.536.267s5.6 0 8.4-.267a2.831 2.831 0 0 0 2.4-2.267 23.986 23.986 0 0 0 .4-5.335 23.986 23.986 0 0 0-.396-5.331zm-13.071 8.4V10l5.6 3.068z",
    transform: "translate(0 -5.2)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8e9c1c58ef85f0455f103a8bce68db01.svg";
export { ForwardRef as ReactComponent };